<template>
    <div>
        <div class="ma-5 text-center" v-if="isLoading">
            <v-progress-circular class="mt-8" indeterminate :width="2"></v-progress-circular>
        </div>
        <v-form v-on:submit.prevent="submit" ref="form" v-else>
            <v-card outlined elevation="0" class="mb-4">
                <v-tabs v-model="tab" grow>
                    <v-tab v-for="lang in tenant.languages" :key="'langtab-' + lang.code">
                        <img :src="lang.icon" style="max-height: 20px" />
                        &nbsp;&nbsp;{{ lang.name }}
                        &nbsp;
                        <v-icon v-if="langOk(department.translations, lang.code, [
                            'name',
                        ])
                        " color="success">
                            {{ icons.mdiCheck }}
                        </v-icon>
                        <v-icon v-else color="error">
                            {{ icons.mdiBlockHelper }}
                        </v-icon>
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item v-for="lang in tenant.languages" :key="'langtabitem-' + lang.code">
                        <div class="px-5 py-10">

                            <v-text-field :id="'department-title-' + lang.code"
                                v-model="department.translations[lang.code].name" :label="$t('Osaston nimi')" outlined
                                class="mb-4" hide-details="auto" :rules="[required]" />


                            <v-switch v-model="department.is_active" :label="$t('Käytössä')"></v-switch>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
                <v-card-text class="mt-0 pt-0">
                    <v-input class="mb-3" hidden hide-details="auto" :rules="[validateLangs]"></v-input>

                    <v-btn type="submit" color="primary">{{ $t('Tallenna') }}</v-btn>
                </v-card-text>
            </v-card>
        </v-form>
    </div>
</template>

<script>
import { getValidTranslations, langOk } from '@/@core/utils/translation_helpers';
import useAuth from '@/useAuth';
import { onMounted, reactive, ref } from '@vue/composition-api';
import { mdiCheck, mdiBlockHelper } from '@mdi/js';
import { i18n } from '@/plugins/i18n';
import adminApi from '@/api/admin';
import { required } from '@/@core/utils/validation';

export default {
    props: ["id"],
    setup(props, { emit }) {
        const { tenant } = useAuth();
        const tab = ref(null);
        const form = ref(null);
        const isLoading = ref(false);

        const department = reactive({
            id: null,
            translations: {},
            is_active: true,
        });

        tenant.value.languages.forEach((lang) => {
            department.translations[lang.code] = {
                title: "",
                description: "",
            };
        });

        const getDepartment = async (id) => {
            isLoading.value = true;
            const response = await adminApi.getDepartment(id);
            if (response.ok) {
                department.id = response.data.id;
                department.is_active = response.data.is_active;
                department.translations = {};
                tenant.value.languages.forEach((lang) => {
                    if (response.data.translations[lang.code]) {
                        department.translations[lang.code] = response.data.translations[lang.code];
                    } else {
                        department.translations[lang.code] = {
                            title: "",
                            description: "",
                        };
                    }
                });
            }
            else {
                alert(response.error);
            }
            isLoading.value = false;
        }

        const submit = async () => {
            var valid = form.value.validate();
            if (valid) {
                const savedepartmentRequest = Object.assign({}, department);

                // Translations
                savedepartmentRequest.translations = getValidTranslations(department.translations, [
                    "name",
                ]);

                var res = await adminApi.saveDepartment(savedepartmentRequest);
                if (res.ok) {
                    emit('saved', res.data.id);
                } else {
                    alert(res.error);
                }
            }
        }

        onMounted(() => {
            if (props.id) {
                getDepartment(props.id);
            }
        });

        const validateLangs = () => {
            let valid = true;
            tenant.value.languages.forEach((lang) => {
                if (!langOk(department.translations, lang.code, ["name"]))
                    valid = false;
            });

            if (valid) {
                return true;
            } else {
                return i18n.t("Nimi on pakollinen kaikilla kielillä");
            }
        };

        return {
            tab,
            form,
            department,
            tenant,
            validateLangs,
            langOk,
            isLoading,
            submit,
            required,
            icons: {
                mdiCheck,
                mdiBlockHelper
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>